import { configureStore } from "@reduxjs/toolkit";
import security from "./security";
import locationAndRoom from "./locationAndRooms";
import topic from "./topic";
import users from "./users";
import bootcamp from "./bootcamp";
import sessionList from "./sessions";
import questionList from "./questions";
import bootcampModuleView from "./bootcampModuleView";
import exercisesList from "./exercises";
import detailsTab from "./SessionView/detailsTab";
import attendeesTab from "./SessionView/attendeesTab";
import exerciseStatusTab from "./SessionView/exerciseStatusTab";
import presentersTab from "./SessionView/presentersTab";
import attendees from "./AttendeesPage/attendees";
import commentsList from "./comments";
import emailModal from "./emailModal";
import utility from "./utility";
import bootcampModule from "./bootcampModule";
import performance from "./performance";
import assessmentQuestions from "./assessmentQuestions";
import assessmentListing from "./assessmentListing";
import createAssessment from "./createAssessment";
import evaluationListing from "./evaluationListing";
import viewAssessmentEvaluation from "./viewAssessmentEvaluation";
import assessmentEvaluations from "./assessments";
import assessmentPlay from "./assessmentPlay";
import formsSlice from "./dynamicForms";
import formBuilderReducer from "./formbuilderSlice";
import triggerSlice from "./triggerSlice";
import formResponseSlice from "./formResponseSlice";
import dashboard from "./dashboard";

export const store = configureStore({
  reducer: {
    security: security,
    bootcamp: bootcamp,
    bootcampModule: bootcampModule,
    locationAndRoom: locationAndRoom,
    topic: topic,
    users: users,
    sessionList: sessionList,
    detailsTab: detailsTab,
    attendeesTab: attendeesTab,
    exerciseStatusTab: exerciseStatusTab,
    presentersTab: presentersTab,
    questionList: questionList,
    assessmentQuestions: assessmentQuestions,
    assessmentListing: assessmentListing,
    createAssessment: createAssessment,
    evaluationListing: evaluationListing,
    viewAssessmentEvaluation: viewAssessmentEvaluation,
    assessmentPlay: assessmentPlay,
    exercisesList: exercisesList,
    commentsList: commentsList,
    bootcampModuleView: bootcampModuleView,
    attendees: attendees,
    sendEmail: emailModal,
    utility: utility,
    performance: performance,
    assessmentEvaluations: assessmentEvaluations,
    forms: formsSlice,
    formBuilder: formBuilderReducer,
    triggers: triggerSlice,
    formResponse: formResponseSlice,
    dashboard: dashboard,

  },
  // devTools: process.env.NODE_ENV !== "production",
});
